import axios from 'utilities/axios';

import { useMutation, useQuery } from 'react-query';

const API = {
  CREATE_ADVERTISER: 'advertisers',
  GET_ADVERTISERS: 'advertisers/filter',
  CLONE_ADVERTISER: (id) => `advertisers/${id}/clone`,
  ADVERTISER: (id) => `advertisers/${id}`,
  UPDATE_ADVERTISER_STATUS: (id) => `advertisers/${id}/status`,
};

export const useGetAdvertisers = (filters) => {
  return useQuery(
    ['getAdvertisers', filters],
    () =>
      axios
        .get(API.GET_ADVERTISERS, {
          params: {
            ...filters,
            terms: filters.terms || undefined,
            sortBy: filters.sortBy || undefined,
            sortDirection: filters.sortBy ? filters.sortDirection : undefined,
          },
        })
        .then((res) => res.data),
    { keepPreviousData: true, enabled: !!filters.page }
  );
};

export const useCreateAdvertiser = () => {
  return useMutation((values) => axios.post(API.CREATE_ADVERTISER, values));
};

export const useGetAdvertiser = (id, options) => {
  return useQuery(
    ['getAdvertiser', id],
    () => axios.get(API.ADVERTISER(id)).then((res) => res.data),
    options
  );
};

export const useUpdateAdvertiser = () => {
  return useMutation((values) => axios.put(API.ADVERTISER(values.id), values));
};

export const useCloneAdvertiser = () => {
  return useMutation((values) =>
    axios.post(API.CLONE_ADVERTISER(values.id), values)
  );
};

export const useUpdateAdvertiserStatus = () => {
  return useMutation((values) =>
    axios.put(API.UPDATE_ADVERTISER_STATUS(values.id), values)
  );
};
